/**
 * Broadcast theme — Social videos section (modified for sound)
 *
 * Change vs. the stock theme file:
 * - Clicking/tapping the play button now plays the video WITH sound.
 * - If a video is already hover-playing muted, one click un-mutes it.
 * - Desktop hover previews stay muted (browsers block un-muted playback
 *   that isn't triggered by a click), with a muted fallback if the
 *   browser blocks un-muted playback for any reason.
 */
(function () {
  'use strict';

  if (customElements.get('social-videos')) return;

  customElements.define(
    'social-videos',
    class SocialVideos extends HTMLElement {
      static allSections = [];

      connectedCallback() {
        SocialVideos.allSections.push(this);
        this.videoItems = this.querySelectorAll('[data-social-video-item]');
        this.videoItems?.forEach((item, index) => this.initVideoItem(item, index));
      }

      initVideoItem(item, index) {
        const video = item.querySelector('video');
        const playButton = item.querySelector('[data-video-play]');
        if (!video || !playButton) return;

        item._video = video;
        item._playButton = playButton;
        item._index = index;

        item.addEventListener('touchstart', () => this.toggleVideo(item));

        // Desktop hover preview — always muted
        item.addEventListener('mouseenter', () => {
          if (item._video.paused) {
            item._video.muted = true;
            this.playVideo(item);
          }
        });

        item.addEventListener('mouseleave', () => this.pauseVideo(item));

        playButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleVideo(item);
        });

        playButton.addEventListener('touchstart', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleVideo(item);
        });
      }

      // Paused → play with sound. Playing muted → un-mute. Playing with sound → pause.
      toggleVideo(item) {
        if (item._video.paused) {
          item._video.muted = false;
          this.playVideo(item);
        } else if (item._video.muted) {
          item._video.muted = false;
        } else {
          this.pauseVideo(item);
        }
      }

      playVideo(item) {
        if (!item._video || !item._video.paused) return;

        this.pauseAllOtherVideos(item);

        const playPromise = item._video.play();
        if (playPromise === undefined) return;

        playPromise
          .then(() => {
            item.classList.add('is-playing');
            item._playButton.setAttribute('aria-label', theme.strings.pauseVideo);
          })
          .catch((error) => {
            // If un-muted playback was blocked by the browser, fall back to muted
            if (!item._video.muted) {
              item._video.muted = true;
              item._video
                .play()
                .then(() => item.classList.add('is-playing'))
                .catch(() => {});
            }
            console.log('Video autoplay prevented:', error);
          });
      }

      pauseVideo(item) {
        if (!item._video || item._video.paused) return;
        item.classList.remove('is-playing');
        item._video.pause();
        item._playButton.setAttribute('aria-label', theme.strings.playVideo);
      }

      pauseAllOtherVideos(current) {
        SocialVideos.allSections.forEach((section) => {
          section.videoItems?.forEach((item) => {
            if (item !== current && item._video && !item._video.paused) {
              this.pauseVideo(item);
            }
          });
        });
      }

      disconnectedCallback() {
        const index = SocialVideos.allSections.indexOf(this);
        if (index > -1) SocialVideos.allSections.splice(index, 1);
      }
    }
  );
})();